export const FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT = {
  frontPageDeEmphasizeCtaExperiment: {
    id: 'reg_1719_front_page-de_emphasize_secondary_cta_experiment',
    variants: {
      VARIANT: 'variant',
    },
  },
};

export const EXPERIMENTS = {
  ...FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT,
};
